module.exports = __webpack_public_path__ + "img/bg_popup_3@2x.53a84647.png";